



























































































































































import Component, { mixins } from 'vue-class-component';
import { currencyFormat, loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { IAnalyticsTopOrganization } from '@/types/types';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import moment from 'moment';
import qs from 'qs';

const analyticsModule = namespace('analytics');

@Component({
  name: 'AnalyticsTopOrganizations',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
  },
  filters: {
    currencyFormat,
    numberFormat: (value: number) => (value ?? 0).toLocaleString(),
  },
})
export default class AnalyticsTopOrganizations extends mixins(WidgetMixins) {
  @analyticsModule.Getter('getTopOrganizations') organizations!: IAnalyticsTopOrganization[];

  startDateMenu: boolean = false;
  endDateMenu: boolean = false;
  startDate: string = moment()
    .subtract(30, 'days')
    .format('YYYY-MM-DD');
  endDate: string = moment().format('YYYY-MM-DD');
  limit: number = 10;

  headers = [
    { text: '#', value: 'rank', sortable: false },
    { text: 'Organization', value: 'organizationName' },
    { text: 'Total Txns', value: 'totalCount', align: 'end' },
    { text: 'Successful', value: 'successCount', align: 'end' },
    { text: 'Success Rate', value: 'successRate' },
    { text: 'Successful Amount', value: 'totalAmount', align: 'end' },
  ];

  chartOptions: any = {
    chart: {
      type: 'bar',
      height: 380,
      background: 'transparent',
      fontFamily: 'Hanken Grotesk, sans-serif',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: { horizontal: true, borderRadius: 4, barHeight: '60%' },
    },
    dataLabels: { enabled: true },
    xaxis: { categories: [] },
    legend: { position: 'top' },
  };

  get isDark(): boolean {
    return this.$vuetify.theme.dark;
  }

  get rankedOrganizations(): Array<IAnalyticsTopOrganization & { rank: number; successRate: number }> {
    return this.organizations.map((organization, index) => ({
      ...organization,
      rank: index + 1,
      successRate: organization.totalCount
        ? Math.round((organization.successCount / organization.totalCount) * 100)
        : 0,
    }));
  }

  get series(): any[] {
    return [
      { name: 'Total Transactions', data: this.organizations.map(organization => organization.totalCount) },
      { name: 'Successful', data: this.organizations.map(organization => organization.successCount) },
    ];
  }

  @Watch('isDark', { immediate: true })
  onThemeChange(dark: boolean): void {
    const foreColor = dark ? '#9AA3AE' : '#545D68';
    const borderColor = dark ? 'rgba(255, 255, 255, 0.1)' : '#E4E7EB';
    this.chartOptions = {
      ...this.chartOptions,
      theme: { mode: dark ? 'dark' : 'light' },
      tooltip: { theme: dark ? 'dark' : 'light' },
      grid: { borderColor },
      chart: { ...this.chartOptions.chart, foreColor, background: 'transparent' },
      colors: [dark ? '#FF3D78' : '#FF0055', dark ? '#34D399' : '#10B981'],
    };
  }

  @Watch('organizations')
  onOrganizationsChange(organizations: IAnalyticsTopOrganization[]): void {
    this.chartOptions = {
      ...this.chartOptions,
      xaxis: { categories: organizations.map(organization => organization.organizationName) },
    };
  }

  @Watch('startDate')
  onStartDateChange(): void {
    this.fetch();
  }

  @Watch('endDate')
  onEndDateChange(): void {
    this.fetch();
  }

  @Watch('limit')
  onLimitChange(): void {
    this.fetch();
  }

  fetch(): void {
    const query = qs.stringify(
      { startDate: this.startDate, endDate: this.endDate, limit: this.limit },
      { addQueryPrefix: true },
    );
    this.$store.dispatch('analytics/fetchTopOrganizations', query);
  }

  created(): void {
    this.fetch();
  }
}
